import DinoAppBar from "../components/DinoAppBar";
import DinoFooter from "../components/DinoFooter";
import React, {useContext, useEffect, useState} from "react";
import {getSubdomain} from "../utils/Utils";
import useCallDataApi from "../hooks/data";
import {Helmet} from "react-helmet";
import {Badge, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import ConfigContext from "../context/ConfigContext";
import CartDrawer from "../components/CartDrawer";
import Fab from "@mui/material/Fab";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import {useCart} from "../context/CartContext";

const Base = ({children, hideCart=false}) => {
    const {getData: fetchBusiness} = useCallDataApi('sp-businesses');
    const {getData: fetchWorkHours} = useCallDataApi('sp-work-hours');
    const [homePageData, setHomePageData] = useState({});
    const [workHours, setWorkHours] = useState({});
    const {config} = useContext(ConfigContext);
    const {openCart, getNumberOfItemsInCart, isCartEmpty} = useCart()

    const getHomePage = () => {
        const subdomain = getSubdomain();
        fetchBusiness(subdomain).then(r => setHomePageData(r));
        fetchWorkHours(`/get_for_business/?business=${subdomain}`).then(r => setWorkHours(r));
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        getHomePage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const theme = useTheme();

    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content={homePageData?.hero_text}
                />
                <meta
                    name="title"
                    content={homePageData?.hero_heading}
                />
            </Helmet>
            {config?.usage_type !== 'only_booking' && (
                <DinoAppBar
                    name={homePageData?.public_name}
                    logo={homePageData?.public_logo}
                />
            )}
            {children}
            <CartDrawer />
            <DinoFooter
                email={homePageData?.public_email}
                phone={homePageData?.public_phone}
                address={homePageData?.public_address}
                logo={homePageData?.public_logo}
                name={homePageData?.public_name}
                workHours={workHours}
                facebook={homePageData?.facebook}
                instagram={homePageData?.instagram}
                youtube={homePageData?.youtube}
                twitter={homePageData?.twitter}
                payment_on={homePageData?.payment_on}
            />
            <div className="promo-footer" style={{ background: theme.palette.primary[700] }}>
                <Typography variant="caption" noWrap>
                    DESIGNED BY <a href="https://vallio.studio/">VALLIO STUDIO</a>
                </Typography>
                <Typography variant="caption" noWrap>
                    CREATED BY <a href="https://trilogic.hu/">TRILOGIC</a>
                </Typography>
            </div>
            {(!isCartEmpty() && !hideCart) && <Badge
                badgeContent={getNumberOfItemsInCart()}
                color="error"
                // overlap="circular"
                sx={{
                    position: "fixed",
                    bottom: theme.spacing(4),
                    right: theme.spacing(4),
                    zIndex: 1001, // Ensures the badge is above other elements
                }}
            >
                <Fab
                    color="primary"
                    aria-label="cart"
                    onClick={openCart}
                >
                    <ShoppingCartIcon/>
                </Fab>
            </Badge>}
        </>
    );
};

export default Base;
